module.exports = __webpack_public_path__ + "static/media/builtinv2-visverlivanie-2 1.e0d3066b.png";